import api from '../../../services/service_item'

export default {
  data () {
    return {
      active_menu: 1,
      currentPage: 1,
      items_perpage: 5,
      menu_data: [],
      menu_list: [],
      items_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  computed: {
    // Menupaginate: function () {
    //   this.totalItem = this.menu_data.length
    //   if (this.currentPage >= this.totalPages) {
    //     this.currentPage = Math.max(0, this.totalPages - 1)
    //   }
    //   var index = (this.currentPage - 1) * this.items_perpage
    //   return this.menu_data.slice(index, index + this.items_perpage)
    // },
    MenupPageList: function () {
      this.totalItem = this.menu_list.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.menu_list.slice(index, index + this.items_perpage)
    }
  },
  created () {
    this.getMenuGroupAll()
  },
  methods: {
    nextPageMenu () {
      if (this.currentPage < 1 || this.currentPage < Math.round(this.menu_list.length / this.items_perpage)) {
        this.currentPage++
      }
    },
    prevPageMenu () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    change_menu (groupCode) {
      this.items_data = []
      this.getMenuGroup(groupCode)
      // this.menu_data.forEach(val => {
      //   if (parseInt(groupCode) === parseInt(val['group_code'])) {
      //     this.items_data = val['items']
      //   }
      // })
      this.$store.state.isLoading = false
    },
    getMenuGroup (groupCode) {
      let payload = {
        group_code: groupCode
      }
      if (groupCode === 1) {
        payload.group_code = ''
      }
      this.$store.state.isLoading = true
      api.itemsALLGroup(
        this.REST_URL,
        this.header,
        payload,
        result => {
          if (result.response === 'success') {
            this.menu_data = result.data
            if (groupCode === 1) {
              this.active_menu = this.menu_list[0]['code']
            } else {
              this.active_menu = groupCode
            }
            // setTimeout(() => {
            this.menu_data.forEach(val => {
              if (parseInt(groupCode) === parseInt(val['group_code'])) {
                this.items_data = val['items']
              }
            })
            // }, 100)
            // this.change_menu(this.active_menu)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลกลุ่มสินค้าไม่ได้',
              description: result.message
            })
            this.$store.state.isLoading = false
          }
        },
        error => {
          this.$store.state.isLoading = false
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getMenuGroupAll (groupCode) {
      api.itemGroup(
        this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.menu_list = result.data
            setTimeout(() => {
              this.change_menu(this.menu_list[0].code)
            }, 100)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลกลุ่มสินค้าไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    addItem (obj) {
      if (this.$store.state.order_data.id) {
        this.$notification['warning']({
          message: 'ไม่สามารถเพิ่มสินค้าได้',
          description: 'กำลังดึงใบพักบิล กรุณาล้างบิลเพื่อทำรายการใหม่'
        })
        return
      }
      let priceItem = obj.bar_data[0]
      // alert(priceItem.price_1 + '|' + priceItem.unit_code + '==' + JSON.stringify(this.$store.state.item_subs))
      var ch = this.$store.state.item_subs.findIndex(row =>
        // parseInt(row.price) === parseFloat(priceItem.price_1) &&
        row.item_barcode === priceItem.barcode &&
        row.unit_code === priceItem.unit_code
      )
      if (ch > -1) {
        this.$store.state.item_subs[ch]['qty'] += parseFloat(1)
        this.$store.state.item_subs[ch]['total_amount'] = this.$store.state.item_subs[ch]['qty'] * this.$store.state.item_subs[ch]['price']
      } else {
        var data = {
          'name': obj.name,
          'unit_code': priceItem.unit_code,
          'item_barcode': priceItem.barcode,
          'qty': parseFloat(1),
          'price': parseFloat(priceItem.price_1),
          'normal_price': parseFloat(priceItem.price_1),
          'total_amount': parseFloat(priceItem.price_1 * 1),
          'item_data': obj,
          'description': ''
        }
        this.$store.state.item_subs.push(data)
      }
      this.$store.state.order_data.item_amount = 0
      this.$store.state.item_subs.forEach(val => {
        this.$store.state.order_data.item_amount += parseFloat(val['qty'] * val['price'])
      })
      this.$store.state.order_data.item_amount = Math.ceil(this.$store.state.order_data.item_amount)
      $('#itemDetailScan').modal('hide')
      $('#itemDetail').modal('hide')
    }
  },
  mounted () {
    // this.getMenuGroupAll()
    // this.getMenuGroup(1)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/itemsRemain.js